import { create } from 'zustand'

const useConfirmationStore = create((set) => ({
    isOpen: false,
    options: {},
    toggleIsOpen: (options) => set((state) => ({ isOpen: !state.isOpen, options: state.isOpen ? {} : options })),
}))

export default useConfirmationStore